import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { Inertia } from '@inertiajs/inertia'

import { Link, usePage, useForm } from '@inertiajs/react'
import { toast } from 'react-toastify'

import Layout from '@/Shared/Layout'
import TrashedMessage from '@/Shared/TrashedMessage'

import Form from './Shared/Form'

const Edit = () => {
    const { hospitals, consumable, type } = usePage().props

    const { data, setData, errors, put, processing } = useForm({
        hospital_id: consumable.hospital_id,
        firm: consumable.firm || '',
        brooms: consumable.brooms || '',
        wiper: consumable.wiper || '',
        normal_waste_21_bag: consumable.normal_waste_21_bag || '',
        normal_waste_30_bag: consumable.normal_waste_30_bag || '',
        normal_waste_39_bag: consumable.normal_waste_39_bag || '',
        furniture_dusters: consumable.furniture_dusters || '',
        disinfectant: consumable.disinfectant || '',
        hand_wash_liquid: consumable.hand_wash_liquid || '',
        air_freshener: consumable.air_freshener || '',
        mop_pads: consumable.mop_pads || '',
        liquid_toilet_cleaner: consumable.liquid_toilet_cleaner || '',
        floor_mops_standard: consumable.floor_mops_standard || '',
        hand_wash_dispenser: consumable.hand_wash_dispenser || '',
        floor_cleaning_towels: consumable.floor_cleaning_towels || '',
        disposable_bed_sheets: consumable.disposable_bed_sheets || '',
        arrived_date: consumable.arrived_date,
        air_freshener_2: consumable.air_freshener_2 || '',
        air_freshener_3: consumable.air_freshener_3 || '',
        type,

        // NOTE: When working with Laravel PUT/PATCH requests and FormData
        // you SHOULD send POST request and fake the PUT request like this.
        _method: 'PUT'
    })

    useEffect(() => {
        Object.values(errors).map(error => {
            toast.error(error)
        })
    }, [errors])

    function handleSubmit(e) {
        e.preventDefault()
        put(route('consumable.update', consumable.id))
    }

    function destroy() {
        if (confirm('Are you sure you want to delete this record?')) {
            Inertia.delete(route('consumable.delete', consumable.id));
        }
    }

    function restore() {
        if (confirm('Are you sure you want to restore this record?')) {
            Inertia.put(route('consumable.restore', consumable.id));
        }
    }

    return (
        <div>
            <Helmet title={data.type} />

            <h1 className="mb-8 text-3xl font-bold">
                <Link
                    onClick={() => history.back()}
                    className="text-indigo-600 hover:text-indigo-700"
                >
                    Consumable
                </Link>
                <span className="mx-2 font-medium text-indigo-600">/</span>
                {data.type}
            </h1>
            {consumable.deleted_at && (
                <TrashedMessage onRestore={restore}>
                    This record has been deleted.
                </TrashedMessage>
            )}
            <div className="max-w-3xl overflow-hidden rounded bg-white p-8 shadow">
                <h1 className="text-2xl font-semibold">Consumable Form</h1>

                <Form
                    hospitals={hospitals}
                    handleSubmit={handleSubmit}
                    data={data}
                    errors={errors}
                    setData={setData}
                    processing={processing}
                    isEdit
                    isDeleted={consumable.deleted_at}
                    destroy={destroy}
                />
            </div>
        </div>
    )
}

Edit.layout = page => <Layout children={page} />

export default Edit
